import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

const Callback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoading } = useAuth0();
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.get("error") === "access_denied") {
      try {
        const desc = decodeURIComponent(params.get("error_description"));
        const errorData = JSON.parse(desc);

        if (errorData.error === "email_not_verified") {
          setError({ email: errorData.email });
        }
      } catch (e) {
        console.error("Error parsing error description:", e);
        navigate('/');
      }
    } else if (!isLoading) {
      navigate('/');
    }
  }, [navigate, isLoading, location.search]);

  if (error?.email) {
    return (
      <div className="contact-page" style={{ minHeight: '100dvh', margin: 0, padding: 0 }}>
        <div className="contact-container" style={{ margin: 0, padding: '2rem' }}>
          <div className="contact-content" style={{ 
            textAlign: 'center',
            maxWidth: '600px',
            width: '100%',
            margin: '0 auto'
          }}>
            <img src="/ChatWDL_logo.png" alt="ChatWDL Logo" className="contact-logo" style={{ marginBottom: '2rem' }} />
            <h2 style={{ marginBottom: '1.5rem' }}>Email Verification Required</h2>
            <p>
              We sent you an email with a verification link to <strong>{error.email}</strong>. 
              Please check your email and click the link to verify your email.
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
              <button 
                onClick={() => navigate('/')} 
                className="login-button"
              >
                Return to Home
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-page" style={{ minHeight: '100dvh', margin: 0, padding: 0 }}>
      <div className="contact-container" style={{ margin: 0, padding: '2rem' }}>
        <div className="contact-content" style={{ 
          textAlign: 'center',
          maxWidth: '600px',
          width: '100%',
          margin: '0 auto'
        }}>
          <img src="/ChatWDL_logo.png" alt="ChatWDL Logo" className="contact-logo" style={{ marginBottom: '2rem' }} />
          <h2 style={{ marginBottom: '1.5rem' }}>Processing authentication...</h2>
          <p>Please wait while we complete your request.</p>
        </div>
      </div>
    </div>
  );
};

export default Callback; 